import EdoPortfolio from './EdoPortfolio';

export default EdoPortfolio;
